import { TxpDisableReason } from 'owa-calendar-configuration';

/**
 * Checks whether or not TXP has been disabled for the user
 * @param txpDisableReason the status of whether or not TXP has been disabled
 */
export default function isTxpDisabled(txpDisableReason: TxpDisableReason): boolean {
    return txpDisableReason !== TxpDisableReason.None;
}
